module.exports = __webpack_public_path__ + "static/media/phone_ring.9a108c0a.svg";